import React from "react";
import { debounce } from 'lodash';
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min.js";
import Swal from "sweetalert2";
import AudioDetection from "../../pages/object-detection/audio-detection";
import Exam_recording from '../../pages/object-detection/Exam_recording_updated.js';
import ObjectDetection from '../../pages/object-detection/object-detection';
import '../../pages/object-detection/styles.css';
import { AssessmentAuditTracks, AssignmentSubmission, GetAssignmentDetail, RemoveFile, SetToFinal, StoreTime, UploadFileToAws, UploadIdentificationImage, uploadTOS3BucketUrl } from "../../services/QualificationService";
import { setAssessmentReview, setCurrAssessment, setIsExamLaunched, updateSubjectContentLoadingOnLesson } from "../../store/actions";
import { dataURLtoFile, getRandomInt } from '../../utils/commonFunction.js';
import { formatToTimeZone } from "../../utils/CommonGroupingItem.js";
import { BASE_URL, UPLOAD_ROOT_PATH } from "../../utils/Constants";
import { handleUploadToS3BucketUrl } from "../common/uploadFileToS3.js";
import Step1 from "./assessmentDetail/Step1";
import Step2 from "./assessmentDetail/Step2";
import Step3 from "./assessmentDetail/Step3";
import Step4 from "./assessmentDetail/Step4";
import Step5 from "./assessmentDetail/Step5";
import Step6 from "./assessmentDetail/Step6";
import Step7 from "./assessmentDetail/Step7";
import { download} from "../../utils/FileDownload.js";
import { tokens } from "../../public/tokens.js";

var camStream = {}
var micStream = {}

const Assignment = (props) => {
  const isMountedRef = useRef(true);
  const { assessmentId } = props;
  const [assignmentDetails, setassignmentDetails] = useState({});
  const [assignmentReload, setAssignmentReload] = useState(false);
  const [step, setStep] = useState(0);
  const [hasCamera, setHasCamera] = useState(false);
  const [hasMicrophone, setHasMicrophone] = useState(false);
  const [isRecord, setIsRecord] = useState(false);
  const [currentMedia, setCurrentMedia] = useState({});
  const [photoId, setPhotoId] = useState("");
  const [showIdentification, setShowIdentification] = useState("");
  const [showSystemCheck, setShowSystemCheck] = useState("");
  const [toolTip, setToolTip] = useState("");
  const [checkShare, setCheckShare] = useState(false);
  const [timesLeft, setTimesLeft] = useState(0);
  const [soundCount, setSoundCount] = useState(0);
  const [noCameraPermission, setNoCameraPermission] = useState('');
  const [resetCount, setResetCount] = useState(0);
  const [quizId, setQuizId] = useState(null)
  const [quiz, setquiz] = useState({});
  const [result, setresult] = useState(false);
  const [maxAttempt, setMaxAttempt] = useState(0);
  const [totalattempt, setTotalattempt] = useState(0);
  const [loader, setLoader] = useState(false);
  const history = useHistory();
  const [assPassMark, setAssPassMark] = useState("");
  const [quizTotalTime, setQuizTotalTime] = useState('0 hour 0 min');
  const [isTimer, setIsTimer] = useState(false);
  const [subId, setSubId] = useState(null);
  const dispatch = useDispatch();
  const { examLaunched } = useSelector(state=>state.examLaunched);
  const [submitQuizAssessment, setSubmitQuizAssessment] = useState(false);
  const [fileSubmitted, setFileSubmitted] = useState(true);
  const [loadFinal, setLoadFinal] = useState(false);
  const [reloadchild, setReloadchild] = useState(false);
  const [switchAway,setSwitchAway] = useState(0);
  const [switchBack,setSwitchBack] = useState(0);
  const [screenShareCheck,setScreenShareCheck] = useState(true);
  const [cameraObj,setCameraObj]= useState({});
  const [loadingNextBtn, setLoadingNextBtn]= useState(false)
  const [doucmentUploaded,setDocumentUploaded] = useState(false)
  const [loadingCamera, setLoadingCamera] = useState(false);
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [hasTimeExpired, setHasTimeExpired] = useState(false);
  const {aid,sid} = useParams();
  const mediaRecorderRef = useRef(null);
  const isStartingRef = useRef(false);
  const currentStreamRef = useRef(null);
  
  const safeSetState = useCallback((setter, value) => {
    if (isMountedRef.current) {
      setter(value);
    }
  }, []);
  
  const brandConfig = useSelector((state) => state.brand);
  var brandInfo = brandConfig.configuration
  const updateSubmitQuizAssessment = () => {
    setSubmitQuizAssessment(false);
  }
  const abortControllerRef = useRef(null); 
  useEffect(()=>{
    dispatch(setAssessmentReview(false))
  },[])
  
  const stopRecording = useCallback(async () => {
    try {
      // Stop media recorder
      if (mediaRecorderRef?.current && mediaRecorderRef?.current.state !== "inactive") {
        mediaRecorderRef.current.stop();
        mediaRecorderRef.current = null;
      }
      
      // Stop stream tracks
      if (currentStreamRef.current) {
        currentStreamRef.current.getTracks().forEach(track => {
          track.stop();
          track.enabled = false;
        });
        currentStreamRef.current = null;
      }

      // Clear state
      safeSetState(setCurrentMedia, null);
      safeSetState(setIsRecord, false);
    }catch(error) {
      console.error("Error stopping recording:", error);
    }
  }, [])

  useEffect(() => {
    if(props?.isExamLaunched){
      localStorage.setItem("Monitoring Object" + aid,JSON.stringify({switchAway : switchAway , soundCount : soundCount,...cameraObj}))
    }
  },[switchAway,soundCount,cameraObj,props?.isExamLaunched])


  useEffect(() => {
    localStorage.removeItem('apiCalled');
  }, []);

  const start = useCallback(async () => {
    // Prevent multiple simultaneous starts
    if (isStartingRef.current) {
      return;
    }
    isStartingRef.current = true;
    try {
      // Clean up any existing recording first
      await stopRecording();                                        
      const stream = await recordScreen();
      // Check if we got a valid stream
      if (!stream || !stream.getTracks || stream.getTracks().length === 0) {
        throw new Error("No valid screen share stream obtained");
      }
      const mimeType = "video/webm";
      const mediaRecorder = createRecorder(stream, mimeType);
      
      // Store references
      mediaRecorderRef.current = mediaRecorder;
      currentStreamRef.current = stream;
      safeSetState(setCurrentMedia, mediaRecorder);
      safeSetState(setScreenShareCheck, true);
      safeSetState(setIsRecord, true);
    } catch (error) {
      console.error("Failed to start screen share:", error);
      safeSetState(setScreenShareCheck, false);
      safeSetState(setIsRecord, false);
      await stopRecording();
    } finally {
      isStartingRef.current = false;
    }
  }, []);
  
  const stop = useCallback(async (isSaved, disabledFileDrop) => {
    if (disabledFileDrop) {
      props.setTab("assessment_latest");
      await stopRecording();
      return;
    }
    
    if (props.isExamLaunched && !isSaved) {
      Swal.fire({
        title: 'Are you sure you want to exit?',
        text: "The countdown will continue even if this tab is closed",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Leave'
      }).then(async function (result) {
        if (result.isConfirmed) {
          await handleExitProcedures();
        }
      });
    } else {
      props.setTab("assessment_latest");
      await stopRecording();
    }
  }, [props.isExamLaunched, assessmentId]);
  
  const cleanupMediaStreams = useCallback(() => {
    try {
      // Stop screen recording
      stopRecording();
      
      // Stop camera stream
      if (camStream && typeof camStream.getTracks === 'function') {
        camStream.getTracks().forEach(track => {
          track.stop();
          track.enabled = false;
        });
        camStream = null;
      }
      
      // Stop microphone stream
      if (micStream && typeof micStream.getTracks === 'function') {
        micStream.getTracks().forEach(track => {
          track.stop();
          track.enabled = false;
        });
        micStream = null;
      }
      
      // Reset refs
      isStartingRef.current = false;
      
    } catch (error) {
      console.error('Error cleaning up media streams:', error);
    }
  }, [stopRecording]);
  
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  
  useEffect(() => {
    if (props.assessmentId) {
      let aid = props.assessmentId;
      GetAssignmentDetail({ aid, intake_id: sid })
      .then((res) => {
        if (!res || !res.data) {
          console.warn("[AssignmentDetail][useEffect] No assignment data found", { res });
          return;
        }
        safeSetState(setDocumentUploaded, false);
        // handling the timezone
        res.data.open_date_time=formatToTimeZone(res?.data?.open_date_time);
        res.data.close_date_time=formatToTimeZone(res?.data?.close_date_time);
        res.data.marking_deadline_date = formatToTimeZone(res?.data?.marking_deadline_date, Intl.DateTimeFormat().resolvedOptions().timeZone);

        props.setIsSubmitDocsAss(false);
        // check hybrid question
        safeSetState(setSubId, res?.data?.subID);
        safeSetState(setAssPassMark, res?.data?.pass_mark);
        let isHybrid = res?.data?.isHybrid;
        
        if (res?.data?.quiz_id) {
          safeSetState(setQuizId, res.data?.quiz_id);
          safeSetState(setMaxAttempt, res.data?.maximum_attempts);
          safeSetState(setTotalattempt, res.data?.totalattempt);
        }else{
          safeSetState(setQuizId, null);
          safeSetState(setMaxAttempt, 0);
          safeSetState(setTotalattempt, 0);
        }
        if(res?.data?.launched === 0){
          if (res.data.status === "Draft") {
            if ((res.data?.camera ? hasCamera ? false : true : false) || (res.data?.audio ? hasMicrophone ? false : true : false) || (res.data?.screen_share ? isRecord ? false : true : false)) {
              safeSetState(setStep, 2);
              setTimeout(() => {
                repeatSysCheck('repeat')
              }, 3000);
            }
            else {
              safeSetState(setStep, 5);
            }
          } else if (
            res.data.status === "Submitted" ||
            (res.data.status === "Closed-Submitted" && (res.data?.quiz_id === 0 || res.data?.quiz_id === null))  ||
            (res.data.status === "Closed-Submitted" && isHybrid)
          ) {
            safeSetState(setStep, 6);            
          } else if (
            res.data?.status === "Closed-Marked" ||
            res.data?.status === "Closed Not-Submitted"
          ) {
            if(res.data?.notify_assessed === 1){
              safeSetState(setStep, 7);
            }else{
              safeSetState(setStep, 6);
            }
          } else {
            if (step === 4) {
              safeSetState(setStep, 5);
            }
            else if (res.data?.status === "Pending" || res.data?.camera || res.data?.audio || res.data?.screen_share || res.data?.identification) {
              safeSetState(setStep, 1);
            }
            else if (res.data?.quiz_id === 0) {
              safeSetState(setStep, 5);
            }
            else {
              safeSetState(setStep, 4);
            }
          }
        }
        
        let timePercent = 0
        if (res.data?.timeLimitActive) {
          let timeLeft = (res.data?.timeHour * 60) + res.data?.timeMin
          timePercent = (timeLeft * 10) / 100
        }        
        safeSetState(setTimesLeft, timePercent);
        safeSetState(setQuizTotalTime, `${res.data?.timeHour || 0} hour ${res.data?.timeMin || 0} min`);
        safeSetState(setassignmentDetails, res.data);
        let identification = res.data?.identification;
        let sysCheck = (res.data?.camera || res.data?.audio) || res.data?.screenshare;
        safeSetState(setShowIdentification, identification ? true : false);
        safeSetState(setShowSystemCheck, sysCheck ? true : false);
        let toolStr =
        "This is a protected exam, to begin this exam you will require " +
        (res.data?.camera ? "operational webcam" : "") +
        (res.data?.camera && res.data?.audio && res.data?.screen_share
          ? ""
          : !res.data?.camera && (res.data?.audio || res.data?.screen_share)
          ? ""
          : " ") +
          (res.data?.camera && res.data?.audio && res.data?.screen_share
            ? ", "
            : res.data?.camera && res.data?.audio && !res.data?.screen_share
            ? "and "
            : "") +
            (res.data?.audio ? "microphone " : "") +
            ((res.data?.camera || res.data?.audio) && res.data?.screen_share
            ? "and "
            : "") +
            (res.data?.screen_share ? "share your screen" : "");
            safeSetState(setToolTip, sysCheck ? toolStr : "This assignment has no conditions");
            safeSetState(setCheckShare, res.data?.screen_share ? true : false);
            if(res?.data?.launched === 1){
              if(res?.data?.quiz_id && res?.data?.remainingDuration > 0){              
                safeSetState(setStep, 4);
              } else {
                if(res?.data?.quiz_id){
                  if(res?.data?.is_student_signature_required){
                    safeSetState(setStep, 5);
                  } else {
                    safeSetState(setStep, 4);
                  }
                }else{
                  safeSetState(setStep, 5);
                }
              }
              props.setIsExamLaunchedToTrue();
              dispatch(setIsExamLaunched({isExamLaunched:true, isClicked:false, url: history.location.pathname}));
            } else {
              props.setIsExamLaunchedToFalse();
              dispatch(setIsExamLaunched({}));
              
            }
          })
          .catch((error) => {
            if (!isMountedRef.current) return;
            console.error(error);
            if(isMountedRef.current){                            
              setDocumentUploaded(prevValue => {
                if(!prevValue){
                  history.push(`/course/${props.courseId}/subject/${props.subjectId}`);
                  props.setTab("assessment_latest");
                  props.setShowAssignment(false);
                }
                return prevValue
              })
            }
          });
        }
  }, [assignmentReload, props.assessmentId]);
      
  useEffect(() => {
    let localData = localStorage.getItem("Monitoring Object"+aid);
    if(localData){
      let data = JSON.parse(localData);
      setSwitchAway(data?.switchAway)
      setSoundCount(data?.soundCount)
      setCameraObj({...cameraObj,phone : data?.phone, person : data?.person, absent : data?.absent})
    }
  },[]);
      
  const debouncedSaveMonitoring = useCallback(
    debounce((data) => {
      try {
        if (props?.isExamLaunched && aid) {
          localStorage.setItem("Monitoring Object" + aid, JSON.stringify(data));
        }
      } catch (error) {
        console.warn('Error saving monitoring data:', error);
      }
    }, 500),
    [aid, props?.isExamLaunched]
  );
      
  useEffect(() => {
    debouncedSaveMonitoring({
      switchAway,
      soundCount, 
      ...cameraObj
    });
  }, [switchAway, soundCount, cameraObj, debouncedSaveMonitoring]);

  const handleTabChanged = (switchAway) => {
    const currentTime = new Date().getTime();
    try{
      const formData = new FormData();
      formData.append('assignment',assessmentId)
      formData.append('warning',`Browser tab changed during assessment: ${switchAway}`)
      formData.append('timestamp',currentTime)
      formData.append('attempt_no',Number(assignmentDetails?.totalattempt || 0) + 1)
      
      UploadFileToAws(formData).then((resp) => {}).catch((err) => {})
      
    }catch(err){
      console.error('Error in audio upload:', err);
    }
  };
      
  useEffect(() => {
    if(switchAway > 0){
      handleTabChanged(switchAway)
    }
  },[switchAway])
      
      
  // Move handleVisibilityChange outside and use useCallback
  const handleVisibilityChange = useCallback(() => {
    if (document.hidden) {
      safeSetState(setSwitchAway, prev => prev + 1);
    } else {
      safeSetState(setSwitchBack, prev => prev + 1);
    }
  }, []);
  
  useEffect(() => {
    return () => {
      // Abort any ongoing operations
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
        abortControllerRef.current = null;
      }
      
      // Clean up all media streams
      cleanupMediaStreams();
      
      // Remove any event listeners
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [cleanupMediaStreams, handleVisibilityChange]);
      
  useEffect(() => {
    if (assignmentDetails?.screen_share && assignmentDetails?.launched) {
      // Safety check
      if (typeof handleVisibilityChange === 'function') {
        document.addEventListener('visibilitychange', handleVisibilityChange);
        
        return () => {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
      }
    }
  }, [assignmentDetails?.screen_share, assignmentDetails?.launched, handleVisibilityChange]); 
      
  useEffect(() => {
    if(assignmentDetails?.launched){
      AssessmentAuditTracks({assId : assessmentId,isClosed : 0})
      .then((res) => {
        
      })
      .catch((err) => {
        
      })
      dispatch(setCurrAssessment({id : assessmentId , isClosed : 0}))
      localStorage.removeItem('apiCalled')
    }
  },[assignmentDetails?.launched])
      
  const nextClick = () => {
    let currentStep = step
    if (currentStep === 1) {
      if (showSystemCheck) {
        safeSetState(setStep, step + 1);
      }
      else if (showIdentification && (!showSystemCheck)) {
        safeSetState(setStep, 3); 
      }
      else {
        safeSetState(setStep, 4); 
      }
    }
    else {
      safeSetState(setStep, step + 1);
    }
    safeSetState(setLoadingNextBtn, false);
  };
      
  const checkShareFun = useCallback(() => {
    if (checkShare && (step === 2 || step === 5)) {
      const shouldStart = !currentMedia?.state || currentMedia?.state === "inactive";
      if (shouldStart && !isStartingRef.current) {
        start();
      }
    } else if (checkShare && (step > 2) && (step < 6)) {
      const shouldStop = currentMedia?.state && currentMedia?.state !== "inactive";
      if (shouldStop) {
        safeSetState(setIsRecord, false);
      }
    }
  }, [checkShare, step, currentMedia, start]);
      
  const repeatSysCheck = async (next) => {
    safeSetState(setLoadingNextBtn, true);
    let isCheckCancelled = false;
    const results = {
      camera: assignmentDetails?.camere ? false :true,
      audio: assignmentDetails?.audio ? false : true,
      screenShare: assignmentDetails?.screen_share ? false :true
    };
    
    // Abort any existing check first
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
    
    // Create new abort controller
    const abortController = new AbortController();
    const signal = abortController.signal;
    abortControllerRef.current = abortController;
    
    // Store current context
    const currentAssessmentId = props.assessmentId;
    const currentSubjectId = sid;
    
    // Event handlers
    let deviceChangeHandler, contextCheckInterval;
    
    // Comprehensive cleanup function
    const cleanup = () => {
      try {
        // Remove event listeners
        if (deviceChangeHandler && navigator.mediaDevices) {
          navigator.mediaDevices.removeEventListener('devicechange', deviceChangeHandler);
        }
        
        // Clear interval
        if (contextCheckInterval) {
          clearInterval(contextCheckInterval);
        }
        
        // Abort controller cleanup
        if (abortController && !abortController.signal.aborted) {
          abortController.abort();
        }
        
        // Clear reference if this is the current controller
        if (abortControllerRef.current === abortController) {
          abortControllerRef.current = null;
        }
        
        safeSetState(setLoadingNextBtn, false);
      } catch (error) {
        console.error('Cleanup error in repeatSysCheck:', error);
      }
    };
    
    try {
      // Early abort check
      if (signal.aborted) {
        cleanup();
        return;
      }
      
      // Define event handlers
      deviceChangeHandler = () => {
        isCheckCancelled = true;
        cleanup();
        
        // Restart after cleanup
        setTimeout(() => {
          if (props.assessmentId === currentAssessmentId && sid === currentSubjectId) {
            repeatSysCheck(next);
          }
        }, 1000);
      };
      
      const handleContextChange = () => {
        if (props.assessmentId !== currentAssessmentId || sid !== currentSubjectId) {
          isCheckCancelled = true;
          cleanup();
        }
      };
      if (navigator.mediaDevices) {
        navigator.mediaDevices.addEventListener('devicechange', deviceChangeHandler);
      }
      contextCheckInterval = setInterval(handleContextChange, 1000);
      if (assignmentDetails.camera && !signal.aborted) {
        if (props.assessmentId !== currentAssessmentId || sid !== currentSubjectId) {
          cleanup();
          return;
        }
        try{
          const cameraResult = await new Promise((resolve, reject) => {
            if (signal.aborted) {
              reject(new Error('Check cancelled'));
              return;
            }
            const timeoutId = setTimeout(() => {
              reject(new Error('Camera check timeout'));
            }, 30000);
            detectWebcam(function (hasWebcam) {
              clearTimeout(timeoutId);
              
              if (signal.aborted || isCheckCancelled) {
                reject(new Error('Check cancelled'));
                return;
              }
              
              if (props.assessmentId !== currentAssessmentId || sid !== currentSubjectId) {
                reject(new Error('Context changed'));
                return;
              }
              const result = hasWebcam ? true : false;
              safeSetState(setHasCamera, result);
              resolve(result);
            }, signal); // Pass abort signal to detectWebcam
            
            signal.addEventListener('abort', () => {
              clearTimeout(timeoutId);
              reject(new Error('Check cancelled'));
            });
          });
          
          results.camera = cameraResult;
        }catch (cameraError) {
          results.camera = false;
        }
        if (signal.aborted || isCheckCancelled) {
          cleanup();
          return;
        }
        
        await new Promise(resolve => setTimeout(resolve, 200));
      }
      
      // Audio check with cleanup
      if (assignmentDetails?.audio  && !signal.aborted && !isCheckCancelled) {
        try {
          const audioResult = await detectAudio(signal);
          results.audio = audioResult;
          
        } catch (audioError) {
          console.error('Audio check failed:', audioError);
          results.audio = false;
        }
        
        if (signal.aborted || isCheckCancelled) {
          cleanup();
          return;
        }              
        await new Promise(resolve => setTimeout(resolve, 500));                          
      }
      
      // Screen share check with cleanup
      if (assignmentDetails?.screen_share && !signal.aborted && !isCheckCancelled) {        
        try {
          if ((!currentMedia?.state) || (currentMedia?.state === "inactive")) {
            safeSetState(setIsRecord, false);
            await start();
          }
          results.screenShare = true;
          safeSetState(setIsRecord, true);
        } catch (error) {
          console.error('Screen share check failed:', error);
          results.screenShare = false;
          safeSetState(setIsRecord, false);
        }
        if (signal.aborted || isCheckCancelled) {
          cleanup();
          
          return;
        }            
        await new Promise(resolve => setTimeout(resolve, 200));
      }
      
      
      // Final check and proceed
      if (!signal.aborted && !isCheckCancelled) {
        const allPassed = results?.camera && results?.audio && results?.screenShare;
        if (allPassed) {
          moveNext(next, results?.camera, results?.audio, results?.screenShare);
        } else {
          console.error('Some system checks failed:', results);
        }
      }
      
    } catch (error) {
      if (error.message.includes('cancelled') || error.message.includes('Context changed')) {
        console.error('System check cancelled:', error.message);
      } else {
        console.error('System check failed:', error);
      }
    } finally {
      // Always cleanup, regardless of success or failure
      cleanup();
    }
  };
      
  const moveNext = async (next, camOk, audioOk, screenOk) => {
    if ((next === 'next') && camOk && audioOk && screenOk) {
      if (assignmentDetails?.identification) {
        safeSetState(setStep, step + 1);
      }
      else {
        safeSetState(setStep, 4);
      }
      
    }
  }
  const detectWebcam = useCallback(async (callback, abortSignal = null) => {
    // Early abort check
    if (abortSignal?.aborted) {
      if (callback && typeof callback === 'function') {
        callback(false);
      }
      return false;
    }
    
    try {
      // Clean up existing stream
      if (camStream?.getTracks) {
        camStream.getTracks().forEach(track => {
          track.stop();
          track.enabled = false;
        });
        camStream = null;
      }
      
      const stream = await navigator.mediaDevices.getUserMedia({ 
        video: { 
          width: { ideal: 1280 },
          height: { ideal: 720 } 
        } 
      });
      
      // Check if aborted during getUserMedia
      if (abortSignal?.aborted) {
        stream.getTracks().forEach(track => track.stop());
        if (callback && typeof callback === 'function') {
          callback(false);
        }
        return false;
      }
      
      camStream = stream;
      if (callback && typeof callback === 'function') {
        callback(true);
      }
      return true;
      
    } catch (error) {
      console.error("Camera detection failed:", error);
      
      // Clean up on error
      if (camStream?.getTracks) {
        camStream.getTracks().forEach(track => track.stop());
        camStream = null;
      }
      
      if (callback && typeof callback === 'function') {
        callback(false);
      }
      return false;
    }
  }, []);
      
  useEffect(() => {
    if ((step > 1) && (step < 6)) {
      let isActive = true;
      const performChecks = async () => {
        if (!isActive) return;

        if (assignmentDetails?.camera || assignmentDetails?.identification) {
          try {
            setLoadingCamera(true);
            await detectWebcam(function (hasWebcam) {
              if (isActive) {
                safeSetState(setHasCamera, !!hasWebcam);
              }
              setLoadingCamera(false);
            });
          } catch (error) {
            console.error('Camera check failed:', error);
            if (isActive) {
              safeSetState(setHasCamera, false);
            }
            setLoadingCamera(false);
          }
        }

        if (assignmentDetails?.audio && isActive) {
          try {
            await detectAudio();
          } catch (error) {
            console.error('Audio check failed:', error);
          }
        }
        if (checkShare && isActive) {
          if ((!currentMedia?.state) || (currentMedia?.state === "inactive")) {
            setIsRecord(false);
            checkShareFun();
          }
        }
      };
      performChecks();
      return () => {
        isActive = false;
      };
    }
  }, [step, assignmentDetails, checkShare, currentMedia, detectWebcam]);
      
  async function detectAudio(abortSignal = null) {
    try {
      // Clean up any existing micStream first
      if (micStream && micStream.getTracks) {
        micStream.getTracks().forEach(track => track.stop());
        micStream = {};
      }
      
      // Check if already aborted
      if (abortSignal && abortSignal.aborted) {
        safeSetState(setHasMicrophone, false);
        return false;
      }
      
      // Create the getUserMedia promise
      const getUserMediaPromise = navigator.mediaDevices.getUserMedia({ audio: true });
      
      // Create abort promise if signal is provided
      let cancelPromise = new Promise(() => { }); // Never resolves if no abort signal
      if (abortSignal) {
        cancelPromise = new Promise((_, reject) => {
          abortSignal.addEventListener("abort", () => {
            reject(new Error("Audio detection aborted"));
          });
        });
      }
      
      // Race between getUserMedia and abort
      const stream = await Promise.race([getUserMediaPromise, cancelPromise]);
      
      // Check if aborted after getting stream
      if (abortSignal && abortSignal.aborted) {
        stream.getTracks().forEach(track => track.stop());
        safeSetState(setHasMicrophone, false);
        return false;
      }
      
      // Store the stream and update state
      micStream = stream;
      safeSetState(setHasMicrophone, true);
      return true;
      
    } catch (err) {
      console.error("detectAudio error:", err.message);
      
      // Clean up any streams that might have been created
      if (micStream && micStream.getTracks) {
        micStream.getTracks().forEach(track => track.stop());
        micStream = {};
      }
      
      safeSetState(setHasMicrophone, false);
      return false;
    }
  }

  const handleExitProcedures = useCallback(async () => {
    try {
      if (localStorage.getItem('apiCalled')) {
        return;
      }

      // API call to track assessment closure
      await AssessmentAuditTracks({ assId: assessmentId, isClosed: 1 });
      dispatch(setCurrAssessment({ id: assessmentId, isClosed: 1 }));
      localStorage.setItem('apiCalled', 'true');
      
      // Stop recording and cleanup
      await stopRecording();
      
      // Update state
      props.setIsExamLaunchedToFalse();
      dispatch(setIsExamLaunched({ ...examLaunched, isExamLaunched: false, isClicked: false }));
      props.parentCall();
      
    } catch (error) {
      console.error("Error during exit procedures:", error);
    }
  }, [assessmentId, stopRecording, examLaunched, dispatch, props]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      handleExitProcedures();
    };

    const handleLoad = () => {
      localStorage.removeItem('apiCalled');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('load', handleLoad);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('load', handleLoad);
    };
  }, [handleExitProcedures]);

  const leaveExamPopup = () => {
    if (examLaunched?.isExamLaunched) {
      Swal.fire({
        title: 'Are you sure you want to exit?',
        text: "The countdown will continue even if this tab is closed",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Continue'
      }).then(function (result) {
        if (result.isConfirmed) {
          AssessmentAuditTracks({assId : assessmentId, isClosed : 1})
          .then((res) => {
            
          })
          .catch((err) => {
            
          })
          dispatch(setCurrAssessment({id : assessmentId, isClosed : 1}))
          localStorage.setItem('apiCalled', 'true');
          currentMedia && currentMedia.stream && currentMedia.stream.getTracks()
          .forEach(track => track.stop())
          safeSetState(setIsRecord, false);
          safeSetState(setCurrentMedia, null);
          dispatch(setIsExamLaunched({...examLaunched, isExamLaunched: false, isClicked: false }));
        }
      })
    }
  }
      
  useEffect(()=>{
    if(assignmentDetails?.timeLimitActive === 0){
      if(examLaunched?.isClicked && assignmentDetails?.launched){
        AssessmentAuditTracks({assId : assessmentId, isClosed : 1})
        dispatch(setCurrAssessment({id : assessmentId, isClosed : 1}))
        localStorage.setItem('apiCalled', 'true');
      }
      dispatch(setIsExamLaunched({isExamLaunched:false, isClicked:false}));
    }else if(examLaunched?.isClicked){
      leaveExamPopup();
    }
    return ()=>{
      dispatch(setIsExamLaunched({...examLaunched, isClicked: false}));
    }
  },[examLaunched?.isClicked])
      
  const recordScreen = useCallback(async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        audio: true,
        video: { mediaSource: "screen" },
      });
      
      // Add event listener for when user stops sharing via browser UI
      stream.getTracks().forEach(track => {
        track.onended = () => {
          stopRecording();
        };
      });
      
      return stream;
    } catch (error) {
      console.error("Error getting display media:", error);
      throw error;
    }
  }, [stopRecording]);
      
  const createRecorder = useCallback((stream, mimeType) => {
    // the stream data is stored in this array
    let recordedChunks = [];
    
    const mediaRecorder = new MediaRecorder(stream);
    
    mediaRecorder.ondataavailable = function (e) {
      if (e.data.size > 0) {
        recordedChunks.push(e.data);
      }
    };
    mediaRecorder.onstop = function () {
      setIsRecord(false)
      recordedChunks = [];
    };
    mediaRecorder.onerror = function (event) {
      console.error("MediaRecorder error:", event.error);
      setIsRecord(false);
    };
    mediaRecorder.start(200); // For every 200ms the stream data will be stored in a separate chunk.
    return mediaRecorder;
  }, []);
      

  async function handleTakePhoto(dataUri,) {
    Swal.fire({
      icon :"success",
      title: "Capturing...",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const file = dataURLtoFile(dataUri, `photo_identification_${props.assessmentId}_${Date.now()}.png`);

      const user = localStorage.getItem("user");
      const userData = JSON.parse(user);
      const randomString = Math.random().toString(36).slice(2, 7);
      const filePath =`Students/${userData?.id}_${userData?.student_crm_id}_${userData?.first_name}_${userData?.last_name}/${assignmentDetails?.id}_${assignmentDetails?.name}/${assignmentDetails?.name}_${userData?.student_crm_id}_${Date.now()}_photo_identification_${randomString}.${file?.name?.split(".").pop()}`;

      let awsFileUploadedUrl = [];

      awsFileUploadedUrl.push({
        file_name: filePath,
        file_type: file.type,
      });

      const resultData = await handleUploadToS3BucketUrl(awsFileUploadedUrl, file);

      const formData = new FormData();
      formData.append('assignment_id', assignmentDetails.id);
      formData.append('attempted_no', Number(assignmentDetails?.totalattempt) + 1);

      resultData.forEach((result) => {
        formData.append(`path`, result.path);
        formData.append(`fileSize`, result.size);
      });

      await UploadIdentificationImage(formData);
      
      safeSetState(setPhotoId, dataUri);
      Swal.close()
      safeSetState(setLoadingNextBtn, false);
    } catch(err) {
      Swal.fire({
        icon: "error",
        title: "Submission Could not be Completed.",
      }).then((result) => {   
        safeSetState(setLoadingNextBtn, false);
      });
    }
  }
    
  const handleClick = () => {
    console.log("i clicked>>>>>")
    // .click())
  }
    
  const retake = () => {
    safeSetState(setPhotoId, "");
  }
    
    
  const getUploadParams = ({ meta }) => {
    return {
      url: 'https://httpbin.org/post'
    }
  }
  const sanitizeFilename = (filename) => {
    // Remove emojis and other problematic Unicode characters
    // This regex removes all non-ASCII characters and special symbols
    return filename
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\x20-\x7E]/g, '')
    .replace(/[^a-zA-Z0-9._\- ]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\s/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
  };
    
  const handleSubmit = async (files, row, setAssignmentReload, setUploadProgress) => {
    safeSetState(setFileSubmitted, false);
    Swal.close();
    if (!files.length) return safeSetState(setFileSubmitted, true);
    
    const formData = new FormData();
    const user = JSON.parse(localStorage.getItem("user"));
    const awsFileUploadedUrl = [];
    const filesToUpload = [];
    files.forEach((f, i) => {
      const ext = f.file.name.split('.').pop();
      const base = sanitizeFilename(f.file.name.split('.').slice(0, -1).join('.')) || `file_${i}_${Date.now()}`;
      const file = new File([f.file], `${base}.${ext}`, { type: f.file.type });
      const path = `Students/${user.id}_${user.student_crm_id}_${user.first_name}_${user.last_name}/${row.id}_${row.name}/${row.name}_${user.student_crm_id}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}.${ext}`;
      
      awsFileUploadedUrl.push({ file_name: path, file_type: file.type });
      filesToUpload.push({ fileWithMeta: f, meta: f.meta, filePath: path });
    });
    
    const result = await handleUploadToS3BucketUrl(awsFileUploadedUrl, files, (e, i) => {
      const id = filesToUpload[i]?.meta?.customId;
      if (id) setUploadProgress(p => ({ ...p, [id]: Math.round((e.loaded * 100) / e.total) }));
    });
    if (!result?.length) {
      Swal.fire({ icon: "error", title: "File Upload Failed", timer: 2000 });
      return safeSetState(setFileSubmitted, true);
    }
    
    result.forEach((item, i) => {
      formData.append(`uploadedFiles[${i}][path]`, item.path);
      formData.append(`uploadedFiles[${i}][size]`, item.size);
    });
    formData.append('assignmentRow1', JSON.stringify(row));
    
    AssignmentSubmission(formData)
    .then(() => {
      files.forEach(f => f.remove());
      safeSetState(setDocumentUploaded, true);
      safeSetState(setAssignmentReload, getRandomInt(5000));
      Swal.fire({
        icon: "success",
        title: "Submission Received",
        text: "To Finalize your submission please set the status to Final.",
        showConfirmButton: true
      });
    })
    .catch(err => {
      const alreadySubmitted = err?.response?.status === 400 && err?.response?.data?.alreadySubmitted;
      Swal.fire({
        icon: alreadySubmitted ? "info" : "error",
        title: alreadySubmitted ? "Assessment already submitted" : "Submission Could not be Completed.",
        text: alreadySubmitted ? err.response.data.message : undefined
      }).then(() => {
        if (alreadySubmitted) initiateReload();
      });
    })
    .finally(() => safeSetState(setFileSubmitted, true));
  };
    
  const handleRemoveFile = (rowId, type, setAssignmentReload, path) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: tokens.colors.brand.blue[500],
      cancelButtonColor: tokens.colors.brand.red[500],
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        RemoveFile({ rowId, type, path })
        .then((res) => {
          safeSetState(setAssignmentReload, getRandomInt(5000));
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Files has been removed successfully",
          }).then((result) => {
            safeSetState(setStep, 5);
          });
        })
      }
    });
  };
  
  const setToFinal = async (row, setAssignmentReload, timeUp, autoSubmitObj) => {
    safeSetState(setLoadFinal, true);
    if (timeUp) {
      const ifPopupQue2 = () => {
        dispatch(setIsExamLaunched({}));
        props.setIsExamLaunchedToFalse();
        safeSetState(setResetCount, getRandomInt(5000));
        try {
          let localData = localStorage.getItem('Monitoring Object' + row?.id)
          if (localData) {
            localStorage.removeItem('Monitoring Object' + row?.id)
          }
        } catch (err) { }
        
        
        Swal.fire({
          title: "Times Up!",
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          backdrop: true,
          onOpen: function () {
            Swal.showLoading();
          },
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.timer) {
            Swal.fire({
              icon: "error",
              title: "Please retry",
              text: "The operation took longer than expected. Would you like to retry?",
              confirmButtonText: "Retry",
              confirmButtonColor: tokens.colors.brand.blue[500],
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              backdrop: true,
            }).then((retryResult) => {
              if (retryResult.isConfirmed) {
                ifPopupQue2()
              }
            })
          }
        })
        SetToFinal({ subID: row.subID === null ? 0 : row.subID, subject: row.subject, assignment: row.id, autoSubmit: 1, ...autoSubmitObj })
        .then((res) => {
          safeSetState(setAssignmentReload, getRandomInt(5000));
          stop()
          //dont remove this its for 
          dispatch(updateSubjectContentLoadingOnLesson("no loading"))
          props.getSubContentMethod();  
          Swal.close();
          Swal.fire({
            icon: "success",
            title: 'Status has been changed',
            showConfirmButton: true
          }).then((result) => {
            safeSetState(setStep, step + 1);
            props.updateSubjectOnly();
          });
        }).catch((error) => {
          if (error?.response?.status === 400 && error?.response?.data?.alreadySubmitted === true) {
            Swal.fire({
              icon: "info",
              title: "Assessment already submitted",
              text: error.response.data.message,
            }).then(() => {
              initiateReload()
            })
          } else {
            Swal.fire({
              icon: "error",
              title: "Submission Interrupted",
              text: "Please check your internet connection and try again.",
              confirmButtonText: "Retry",
              confirmButtonColor: tokens.colors.brand.blue[500],
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              backdrop: true,
            }).then((retryResult) => {
              if (retryResult.isConfirmed) {
                ifPopupQue2()
              }
            })
          }
        }).finally(() => {
          safeSetState(setLoadFinal, false);
        });
      }
      
      ifPopupQue2()
    } else {
      const elsePopupQue2 = () => {
        Swal.fire({
          title: 'Are you sure?',
          text: "Do you want to change the submission to Final Status? You will not be able to edit the submission once you do this.",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'I am sure'
        }).then(function (result) {
          if (result.isConfirmed) {
            dispatch(setIsExamLaunched({}));
            Swal.fire({
              title : "Loading",
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              backdrop: true,
              onOpen: function () {
                Swal.showLoading();
              },
            }).then((result) => {
              if(result.dismiss === Swal.DismissReason.timer){
                Swal.fire({
                  icon: "error",
                  title: "Please retry",
                  text: "The operation took longer than expected. Would you like to retry?",
                  showCancelButton: true,
                  confirmButtonText: "Retry",
                  cancelButtonText: "Cancel",
                  confirmButtonColor: tokens.colors.brand.blue[500],
                  cancelButtonColor: tokens.colors.brand.red[500],
                }).then((retryResult) => {
                  if(retryResult.isConfirmed){
                    elsePopupQue2()
                  }
                })
              }
            })
            props.setIsExamLaunchedToFalse();
            safeSetState(setResetCount, getRandomInt(5000));
            try {
              let localData = localStorage.getItem('Monitoring Object' + row?.id)
              if (localData) {
                localStorage.removeItem('Monitoring Object' + row?.id)
              }
            } catch (err) { }
            SetToFinal({ subID: row.subID === null ? 0 : row.subID, subject: row.subject, assignment: row.id })
            .then((res) => {
              safeSetState(setAssignmentReload, getRandomInt(5000));
              stop()
              Swal.close();
              Swal.fire({
                icon: "success",
                title: 'Status has been changed',
                showConfirmButton: true
              }).then((result) => {
                safeSetState(setStep, step + 1);
              });
            })
            .catch((error) => {
              if (error?.response?.status === 400 && error?.response?.data?.alreadySubmitted === true) {
                Swal.fire({
                  icon: "info",
                  title: "Assessment already submitted",
                }).then(() => {
                  initiateReload();
                })
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Submission Interrupted",
                  text: "Please check your internet connection and try again.",
                  confirmButtonText: "Retry",
                  confirmButtonColor: tokens.colors.brand.blue[500],
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  backdrop: true,
                }).then((retryResult) => {
                  if (retryResult.isConfirmed) {
                    elsePopupQue2()
                  }
                })
              }
            }).finally(() => {
              safeSetState(setLoadFinal, false);
            });
          }
        }).finally(() => {
          safeSetState(setLoadFinal, false);
        });
      }
      elsePopupQue2()
      
    }
  };
      
  useEffect(()=>{
    if(props.isSubmitDocsAss !== null && props.isSubmitDocsAss && props.isExamLaunched){
      setToFinal(assignmentDetails, setAssignmentReload, true);
    }
  },[props.isSubmitDocsAss]);
    
  const downloadOnly = async (absolutePath, fileName, index, timeLimitActive, setAssignmentReload, startTime, path_size = '', isLaunchedAndDownload, isOnlyDownload) => {
    safeSetState(setLoader, true);
    if(isLaunchedAndDownload){
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to launch the assessment and download the assessment files?",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure',
        html: `Do you want to download assessment files? ${path_size && `<br/><br/><b>File Size: ${path_size}</b>`}`,
      }).then(async (result) => {
        if (result.isConfirmed && isMountedRef.current) {
          props.setIsSubmitDocsAss(false);
          props.setIsExamLaunchedToTrue()
          safeSetState(setIsTimer, true);
          dispatch(setIsExamLaunched({...examLaunched, isExamLaunched:true}));
          StoreTime({ assId: index })
          .then((res) => {
            if (!isMountedRef.current) return;
            Swal.close();
            Swal.fire({
              icon: "success",
              title: 'Assessment Launched',
              showConfirmButton: true
            }).then(async (result) => {
              if (!isMountedRef.current) return;
              safeSetState(setAssignmentReload, getRandomInt(5000));
              safeSetState(setResetCount, getRandomInt(5000));
              try{
                safeSetState(setSoundCount, 0);
                safeSetState(setCameraObj, {});
                safeSetState(setSwitchAway, 0);
                localStorage.removeItem("Monitoring Object"+aid)
              }catch(err){
                
              }
              safeSetState(setReloadchild, true);
              let value = false;
              if (absolutePath === '') {
                value = true
              }
              else {
                value = await download(absolutePath, fileName);
              }
              if (value) {
                safeSetState(setAssignmentReload, getRandomInt(5000));
              }
              safeSetState(setLoader, false);
            });
          })
          .catch((error) => {
            if (!isMountedRef.current) return;
            Swal.fire({
              icon: "error",
              title: "Assessment Could not be Started.",
              text: error,
            }).then((result) => { });
            safeSetState(setLoader, false);
          });
        }
      }).finally(()=>{
        if (isMountedRef.current) { // Add this check
          safeSetState(setLoader, false);
        }
      })
    } else if (isOnlyDownload){
      if (!isMountedRef.current) return;
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to download the assessment files?",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure',
        html: `Do you want to download assessment files? <br/><br/><b>File Size: ${path_size}</b>`,
      }).then(async (result) => {
        if (result.isConfirmed && isMountedRef.current) {
          await download(absolutePath, fileName);
        }
        safeSetState(setLoader, false);
      }).finally(()=>{
        safeSetState(setLoader, false);
      })
    } else {
      if (!isMountedRef.current) return;
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to launch the assessment?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure',
      }).then(async (result) => {
        if (result.isConfirmed && isMountedRef.current) {
          dispatch(setIsExamLaunched({...examLaunched, isExamLaunched:true}));
          StoreTime({ assId: index })
          .then((res) => {
            Swal.close();
            Swal.fire({
              icon: "success",
              title: 'Assessment Launched',
              showConfirmButton: true
            }).then(async (result) => {
              safeSetState(setAssignmentReload, getRandomInt(5000));
              safeSetState(setResetCount, getRandomInt(5000));
              try{
                safeSetState(setSoundCount, 0);
                safeSetState(setCameraObj, {});
                safeSetState(setSwitchAway, 0);
                localStorage.removeItem("Monitoring Object"+aid)
              }catch(err){
                
              }
              safeSetState(setReloadchild, true);
              let value = false;
              if (absolutePath === '') {
                value = true
              }
              if (value) {
                safeSetState(setAssignmentReload, getRandomInt(5000));
              }
              safeSetState(setLoader, false);
            });
          })
          .catch((error) => {
            if (!isMountedRef.current) return;
            Swal.fire({
              icon: "error",
              title: "Assessment Could not be Started.",
              text: error,
            }).then((result) => { });
            setLoader(false)
          });
          props.setIsSubmitDocsAss(false);
          props.setIsExamLaunchedToTrue()
          safeSetState(setIsTimer, true);
        }
      }).finally(()=>{
        if (isMountedRef.current) { // Add this check
          safeSetState(setLoader, false);
        }
      })
    }
  }
    
  const stepUpdate = (newStep) => {
    safeSetState(setStep, newStep)
  }
      
  const reAttemptQuiz = () => {
    if(assignmentDetails?.camera || assignmentDetails?.audio || assignmentDetails?.screen_share || assignmentDetails?.identification){
      safeSetState(setStep, 1)
      return
    }
    if(maxAttempt > totalattempt){
      safeSetState(setStep, 4)
    }
  }
    
  const initiateReload = () => {
    safeSetState(setAssignmentReload, getRandomInt(5000))
  }
    
  const handleAudioRecorded = async (audioData) => {
    const currentTime = new Date().getTime();
    try {
      // Create FormData
      const fileName = `audio_${currentTime}.mp3`;      
      const user = localStorage.getItem("user");
      const userData = JSON.parse(user);
      const randomString = Math.random().toString(36).slice(2, 7);
      const formData = new FormData();
      const path =`Students/${userData?.id}_${userData?.student_crm_id}_${userData?.first_name}_${userData?.last_name}/${assignmentDetails?.id}_${assignmentDetails?.name}/Exam Warning/${assignmentDetails?.name}_${userData?.student_crm_id}_${Date.now()}_${randomString}.${fileName?.split(".").pop()}`;
      const fileDetails = [{
        file_name: path,
        file_type: audioData.type, 
      }]
      formData.append("uploadFiles", JSON.stringify(fileDetails));
      const res = await uploadTOS3BucketUrl(formData);
      const uploadURL = res?.data?.data[0]?.uploadURL
      const fileKey = res?.data?.data[0]?.fileKey;

      const uploadAudioWithXHR = (uploadURL, audioData, contentType, onProgress) => {
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();

          xhr.open("PUT", uploadURL, true);
          xhr.setRequestHeader("Content-Type", contentType);

          xhr.upload.onprogress = (event) => {
            if (event.lengthComputable && typeof onProgress === "function") {
              onProgress(Math.round((event.loaded / event.total) * 100));
            }
          };

          xhr.onload = () => {
            if (xhr.status === 200) {
              resolve({
                config: { data: { size: audioData.size } },
                status: xhr.status,
                statusText: xhr.statusText,
              });
            } else {
              reject(new Error(`Audio upload failed: ${xhr.status} ${xhr.statusText}`));
            }
          };

          xhr.onerror = () => reject(new Error("Network error during audio upload"));
          xhr.ontimeout = () => reject(new Error("Audio upload timeout"));

          xhr.send(audioData);
        });
      };

      const uploadFileResponse = await uploadAudioWithXHR(uploadURL, audioData, audioData.type);
      const fileSize = uploadFileResponse?.config?.data?.size || audioData.size;


      let payload = {
        assignment : assignmentDetails?.id,
        path : fileKey,
        attempt_no : Number(assignmentDetails?.totalattempt || 0) + 1,
        size : fileSize,
        warning : `Noise detected: ${soundCount}`,
        timestamp : currentTime
      }
      const uplo = await UploadFileToAws(payload)
    } catch (error) {
      console.error('Error in audio upload:', error);
    }
  };

  /**
   * REAL-TIME TIME EXPIRY WATCHER
   * Runs during Step5 upload to detect time expiry immediately
   */
  useEffect(() => {
    // Only run during upload step (Step5) with all conditions met
    if (step !== 5 || !assignmentDetails?.launched || !assignmentDetails?.timeLimitActive || hasTimeExpired) {
      return;
    }

    let initialServerTime = assignmentDetails.nowtimestamp;
    let startPerf = performance.now();

    const getLiveNow = () => {
      const elapsed = Math.floor((performance.now() - startPerf) / 1000);
      return initialServerTime + elapsed;
    };

    const checkTimeExpired = () => {
      const now = getLiveNow();
      const totalSeconds = ((assignmentDetails.timeHour || 0) * 3600) + ((assignmentDetails.timeMin || 0) * 60);
      const endTime = assignmentDetails.startTime + totalSeconds;

      if (now >= endTime) {
        console.log("[TIME EXPIRED] Time expired during upload - showing modal");
        setHasTimeExpired(true);
        setShowTimeoutModal(true);
      }
    };

    const interval = setInterval(checkTimeExpired, 1000);
    return () => clearInterval(interval);
  }, [step, assignmentDetails?.launched, assignmentDetails?.timeLimitActive, assignmentDetails?.startTime, assignmentDetails?.timeHour, assignmentDetails?.timeMin, assignmentDetails?.nowtimestamp, hasTimeExpired]);

  /**
   * Show modal when time expires during upload
   */
  useEffect(() => {
    if (!showTimeoutModal) return;

    Swal.fire({
      icon: "warning",
      title: "Time is up!",
      html: `
        <div class="text-center">
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p>Your time is up, the system will finish uploading any files currently being uploaded and set to final, please</p>
          <p class="text-danger font-weight-bold">DO NOT CLOSE THIS WINDOW UNTIL UPLOAD IS COMPLETE</p>
        </div>
      `,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      showCancelButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }, [showTimeoutModal]);

  return (
    <span className="exam-steps">
      {step === 1 && <Step1
        showIdentification={showIdentification}
        showSystemCheck={showSystemCheck}
        toolTip={toolTip}
        onNext={nextClick}
        backBtn={() => { props.parentCall() }}
        data={assignmentDetails}
        quizId={quizId}
        maxAttempt={maxAttempt}
      />}

      {step === 2 && <Step2
        loadingNextBtn={loadingNextBtn}
        setLoadingNextBtn={setLoadingNextBtn}
        showIdentification={showIdentification}
        showSystemCheck={showSystemCheck}
        toolTip={toolTip}
        onNext={() => {
          repeatSysCheck('next');
        }}
        backBtn={() => { stop(); props.parentCall() }}
        hasCamera={hasCamera}
        hasMicrophone={hasMicrophone}
        isRecord={isRecord}
        repeatBtn={() => repeatSysCheck('repeat')}
        data={assignmentDetails}
        stepUpdate={stepUpdate}
      />}

      {step === 3 && <Step3
        showIdentification={showIdentification}
        loadingNextBtn={loadingNextBtn}
        setLoadingNextBtn={setLoadingNextBtn}
        showSystemCheck={showSystemCheck}
        toolTip={toolTip}
        onNext={nextClick}
        backBtn={() => { stop(); props.parentCall() }}
        data={assignmentDetails}
        handleTakePhoto={handleTakePhoto}
        photoId={photoId}
        handleClick={handleClick}
        retake={retake}
        stepUpdate={stepUpdate}
        hasCamera={hasCamera}
        hasMicrophone={hasMicrophone}
        isRecord={isRecord}
        noCameraPermission={noCameraPermission}
        loadingCamera={loadingCamera}
      />}

      {step === 4 && <Step4
        assessmentId={props.assessmentId}
        showIdentification={showIdentification}
        showSystemCheck={showSystemCheck}
        toolTip={toolTip}
        onNext={nextClick}
        backBtn={() => { dispatch(setIsExamLaunched({...examLaunched, isClicked: true})); }}
        data={assignmentDetails}
        photoId={photoId}
        launchDownload={({isLaunchedAndDownload,isOnlyDownload}) =>{
          downloadOnly(
            assignmentDetails?.assFile.includes("https") ? assignmentDetails?.assFile : BASE_URL + "/" + assignmentDetails?.assFile.replaceAll(`${UPLOAD_ROOT_PATH}/`, "").replace("public/","").replace("null/",""),
            assignmentDetails?.assFileName,
            assignmentDetails?.id,
            assignmentDetails?.timeLimitActive,
            setAssignmentReload,
            assignmentDetails?.startTime,
            assignmentDetails?.path_size,
            isLaunchedAndDownload,
            isOnlyDownload
          )}}
        stepUpdate={stepUpdate}
        setSoundCount={setSoundCount}
        setCameraObj={setCameraObj}
        setSwitchAway={setSwitchAway}
        hasCamera={hasCamera}
        hasMicrophone={hasMicrophone}
        isRecord={isRecord}
        brandInfo={brandInfo}
        quizId={quizId}
        setStep={setStep}
        setQuizId={props.setQuizId}
        setshow={props.setshow}
        setrId={props.setrId}
        rId={props.rId}
        desc={props.desc}
        attemp={props.attempt}
        ques={props.ques}
        review={props.review}
        setquiz={setquiz}
        setresult={setresult}
        quiz={quiz}
        result={result}
        setMaxAttempt={setMaxAttempt}
        maxAttempt={maxAttempt}
        setIsExamLaunchedToTrue={props.setIsExamLaunchedToTrue}
        setIsExamLaunchedToFalse={props.setIsExamLaunchedToFalse}
        setAssignmentReload={()=>setAssignmentReload(getRandomInt(5000))}
        loader={loader}
        setResetCount={setResetCount}
      />}
      {(step === 5 && Object.keys(assignmentDetails).length !== 0) ? <Step5
        updateSubjectOnly={props.updateSubjectOnly}
        reloadchild={reloadchild}
        getSubContentMethod={props.getSubContentMethod}
        assessmentId={props.assessmentId}
        showIdentification={showIdentification}
        showSystemCheck={showSystemCheck}
        toolTip={toolTip}
        onNext={nextClick}
        backBtn={(disabledFileDrop) => stop(undefined,disabledFileDrop)}
        data={assignmentDetails}
        launchDownload={({isLaunchedAndDownload,isOnlyDownload}) =>{
          downloadOnly(
            assignmentDetails?.assFile.includes("https") ? assignmentDetails?.assFile : BASE_URL + "/" + assignmentDetails?.assFile.replaceAll(`${UPLOAD_ROOT_PATH}/`, "").replace("public/","").replace("null/",""),
            assignmentDetails?.assFileName,
            assignmentDetails?.id,
            assignmentDetails?.timeLimitActive,
            setAssignmentReload,
            assignmentDetails?.startTime,
            assignmentDetails?.path_size,
            isLaunchedAndDownload,
            isOnlyDownload
          )}}
        timesLeft={timesLeft}
        getUploadParams={getUploadParams}
        onSubmit={(files, setUploadProgress) => handleSubmit(files, assignmentDetails, setAssignmentReload, setUploadProgress)}
        handleRemoveFile={(item) =>
          handleRemoveFile((item.id === 0 ? subId : item.id), (item.isInArray && item.id !== 0) ? "file_id" : "sub_id", setAssignmentReload, item.isInArray ? item.path : item.subFilePath)
        }
        setToFinal={(timeUp,autoSubmitObj) => setToFinal(assignmentDetails, setAssignmentReload, timeUp, autoSubmitObj)}
        setAssignmentReload={setAssignmentReload}
        stepUpdate={stepUpdate}
        hasCamera={hasCamera}
        hasMicrophone={hasMicrophone}
        isRecord={isRecord}
        screenShareCheck={screenShareCheck}
        brandInfo={brandInfo}
        quizId={quizId}
        setQuizId={props.setQuizId}
        setshow={props.setshow}
        setrId={props.setrId}
        rId={props.rId}
        desc={props.desc}
        attemp={props.attempt}
        ques={props.ques}
        review={props.review}
        setquiz={setquiz}
        setresult={setresult}
        quiz={quiz}
        result={result}
        maxAttempt={maxAttempt}
        initiateReload={initiateReload}
        isSubmiting={props.isSubmiting}
        stop={stop}
        setIsExamLaunchedToFalse={props.setIsExamLaunchedToFalse}
        assPassMark={assPassMark}
        quizTotalTime={quizTotalTime}
        isTimer={isTimer}
        submitQuizAssessment={submitQuizAssessment}
        updateSubmitQuizAssessment={updateSubmitQuizAssessment}
        fileSubmitted={fileSubmitted}
        setFileSubmitted={setFileSubmitted}
        loader={loader}
        loadFinal={loadFinal}
        parentCall={props.parentCall}
        doucmentUploaded={doucmentUploaded}
        setDocumentUploaded={setDocumentUploaded}
        hasTimeExpired={hasTimeExpired}
        onTimeExpired={() => setShowTimeoutModal(true)}
      /> : null}

      {step === 6 && <Step6
        showIdentification={showIdentification}
        showSystemCheck={showSystemCheck}
        setShowSystemCheck={setShowSystemCheck}
        setCheckShare={setCheckShare}
        setShowIdentification={setShowIdentification}
        setToolTip={setToolTip}
        toolTip={toolTip}
        onNext={nextClick}
        backBtn={() => { stop(); props.parentCall() }}
        data={assignmentDetails}
        quizId={quizId}
        maxAttempt={maxAttempt}
        totalattempt={totalattempt}
        reAttemptQuiz={reAttemptQuiz}
        setStep={setStep}
      />}

      {step === 7 && <Step7
        showIdentification={showIdentification}
        showSystemCheck={showSystemCheck}
        toolTip={toolTip}
        backBtn={() => { stop(); props.parentCall() }}
        openAppealCall={props.openAppealCall}
        data={assignmentDetails}
        reAttemptQuiz={reAttemptQuiz}
        totalattempt={totalattempt}
        maxAttempt={maxAttempt}
        quizId={quizId}
        gradingStandard={props.gradingStandard}
        setStep={setStep}
      />}



      {(step > 1 && step <= 5) ?
        <div>
          {(assignmentDetails.camera || assignmentDetails.audio || assignmentDetails.screen_share) ?
            <div className={`textseries-content-records ${(step === 2 || step === 3) ? 'd-none' : ''}`}>
              <div className="row">
                <div className="col-md-6 mb-15">
                  <div className="audio-video-box">
                    <div className="sound-wave-recognize">
                      <figure>
                        {(assignmentDetails.camera && hasCamera) ?
                          <Exam_recording />
                          : null
                        }
                      </figure>
                    </div>
                    {step >= 4 && (assignmentDetails.audio && hasMicrophone) ?
                      <AudioDetection brandInfo={brandInfo} onSoundCountChange={setSoundCount} prevSoundCount={soundCount} data={assignmentDetails} onAudioRecorded={handleAudioRecorded} resetCount={resetCount} />
                      : null}
                  </div>
                </div>
                {step >= 4 && <div className="col-md-6 mb-15">
                  {(assignmentDetails.camera || assignmentDetails.audio || assignmentDetails.screen_share) ?
                    <ObjectDetection videoWidth={'No'} videoHeight={'No'} setCameraObj={setCameraObj} cameraObj={cameraObj} soundCount={soundCount} data={assignmentDetails} hasCamera={hasCamera}
                      resetCount={resetCount} switchAway={switchAway} switchBack={switchBack}/>
                    : null}
                </div>}
              </div>
            </div>
            : null
          }
        </div>
        :
        null
      }
    </span>
  );
}
export default Assignment;